import { useEffect, useState } from "react";
import {Edit } from "lucide-react";

import useDocumentTitle from '../../hooks/useDocumentTitle';
import { fetchstores } from "../../services/api";
import Pagination from "../../hooks/Pagination";
import ShimmerLoader from "../../hooks/ShimmerLoader";
import { useNavigate } from 'react-router-dom';

export default function Store() {
  useDocumentTitle('Welcome to Admin | Store');
  const [storelist, setStoreList] = useState("");
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [error, setError] = useState('');
  // const [formData, setFormData] = useState({
  //   userType: "B2C",
  //   title: "",
  //   name: "",
  //   lname: "",
  //   email: "",
  //   mobile: "",
  //   address: "",
  // });
  const perPage = 20;
  const fetchstoreslist = async (perPage, currentPage) => {
    try {
      const response = await fetchstores(perPage, currentPage);
      const data = await response.data;
      setStoreList(data.data || data);
      setCurrentPage(data.current_page);
      setTotalPages(data.last_page);
    } catch (err) {
      setError(err.message || 'Failed to fetch Loyalty Card');
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchstoreslist(perPage, currentPage);
  }, [currentPage]);
  // const handleChange = (e) => {
  //   const { name, value } = e.target;
  //   setFormData(prev => ({ ...prev, [name]: value }));
  // };
  const handleEdit = ((item) => {

    localStorage.removeItem('storeEditData');
    localStorage.setItem('storeEditData', JSON.stringify(item));
    navigate('/store/edit');
  })

  return (
    <div className="flex flex-col md:flex-row gap-4 md:gap-4">
      {error && <div style={{ color: 'red' }}>{error}</div>}
      <div className="w-full  bg-white shadow-lg rounded-2xl p-6">
        <h2 className="text-2xl font-bold mb-4">Store/Event List</h2>
        <div className="overflow-auto">

          <table className="w-full text-sm text-left">
            <thead className="text-gray-700 bg-gray-100">
              <tr>
                <th className="p-3">ID</th>
                <th className="p-3">Store Name</th>
                <th className="p-3">Email</th>
                <th className="p-3">Contact Name</th>
                <th className="p-3">Vendor Type</th>
                <th className="p-3">City</th>
                {/* <th className="p-3">Created On</th> */}
                <th className="p-3 text-center">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y">
              {loading ? (
                <>
                  <tr>
                    <td className="p-3" colSpan={8}>
                      <ShimmerLoader />
                      <ShimmerLoader />
                      <ShimmerLoader />
                    </td>
                  </tr>
                </>
              ) : (
                <>
                  {storelist.length > 0 ? (
                    storelist.map((item) => (
                      <tr key={item.id}>
                        <td className="p-3">{item?.id}</td>
                        <td className="p-3">{item?.store_name}</td>
                        <td className="p-3">{item?.email} <br/> {item?.phone}</td>
                        <td className="p-3">{item?.contact_name}</td>
                        <td className="p-3">{(item.vendortype == 0)?'Store':'Event'}</td>
                        <td className="p-3">{item?.fullRegionName}</td>
                        {/* <td className="p-3">{item?.createdDate}</td> */}
                        <td className="p-3 text-center space-x-2">
                          <button className="text-[#f4a406] hover:underline inline-flex items-center gap-1" onClick={() => handleEdit(item)}>
                            <Edit size={16} />
                          </button>
                          {/* <button className="text-red-500 hover:underline inline-flex items-center gap-1">
                                  <Trash2 size={16} />
                                </button> */}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td className="p-3" colSpan={7}>
                        No record found
                      </td>
                    </tr>
                  )}

                </>
              )}

            </tbody>
          </table>
          <Pagination totalPages={totalPages} currentPage={currentPage} setCurrentPage={setCurrentPage} />
        </div>
      </div>
    </div>
  );
}
